import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { MsalService, MsalGuard, MsalBroadcastService } from '@azure/msal-angular';

export function provideMsalServices(): EnvironmentProviders {
    return makeEnvironmentProviders([MsalService, MsalGuard, MsalBroadcastService]);
}
